import React from "react";
import { type DropdownWithoutOptionsProps } from "../models";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";

const BankAccountFormatDropdown = (props: DropdownWithoutOptionsProps<server.dto.BankAccountFormat, server.dto.BankAccountFormats>) => {
  return <BaseReactSelectDropdown
    excludeKeys={props.excludeKeys}
    options={serverReference.bankAccountFormats}
    getLabel={f => f.text}
    getValue={(f) => f.value}
    value={props.value}
    onChange={props.onChange}
    onEsc={props.onEsc}
    config={props.config}
  />;
};

export default BankAccountFormatDropdown;